import React, { useState } from "react";
import { getOptimizedImageUrl } from "../lib/cms";
import LightboxModal from "./LightboxModal";

export default function GallerySection({
  title = "Galleri",
  subtitle = "Se eksempler på udført træarbejde og professionelt udstyr",
  images = [],
  className = "",
}) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(0);

  if (!images || images.length === 0) return null;

  const handleOpenImage = (index) => {
    setSelectedIdx(index);
    setLightboxOpen(true);
  };

  return (
    <section className={`py-12 sm:py-16 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {(title || subtitle) && (
          <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12">
            {title && (
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#12281D] tracking-tight">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-3 text-base sm:text-lg text-[#4E685A] leading-relaxed">
                {subtitle}
              </p>
            )}
            <div className="w-16 h-1 bg-[#D9691E] mx-auto mt-4 rounded-full" />
          </div>
        )}

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {images.map((imgUrl, idx) => (
            <div
              key={idx}
              onClick={() => handleOpenImage(idx)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOpenImage(idx);
                }
              }}
              tabIndex={0}
              role="button"
              aria-label={`Åbn billede ${idx + 1} af ${images.length} i stor visning`}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden bg-[#E9E2D5] cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#D9691E]"
            >
              <img
                src={getOptimizedImageUrl(imgUrl, 600, 80)}
                alt={`Caspers Træservice opgave ${idx + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />

              {/* Hover overlay with zoom icon */}
              <div className="absolute inset-0 bg-[#0E1F16]/50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center p-4">
                <span className="w-11 h-11 rounded-full bg-[#1E4231]/90 text-white flex items-center justify-center text-sm shadow-md border border-white/20 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-200">
                  <i className="fa-solid fa-magnifying-glass-plus" aria-hidden="true" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      <LightboxModal
        images={images}
        currentIndex={selectedIdx}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
      />
    </section>
  );
}
